var map = {
	"./banner-product-1.png": 344,
	"./banner-product-2.png": 345,
	"./handshq-grey@2x.png": 226,
	"./handshq-white@2x.png": 227,
	"./hhq-logo-grey.png": 630,
	"./hhq-logo-white.png": 631,
	"./ic-error.png": 225,
	"./ic-role-custom.png": 632,
	"./ic-role-hs.png": 633,
	"./ic-role-pm.png": 634,
	"./ic-role-sup.png": 635,
	"./results-cost.png": 228,
	"./results-fixing.png": 229,
	"./results-share.png": 230,
	"./results-time.png": 231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 629;